export default __webpack_public_path__ + "c16d2464dfa25f8c9185137f105e0423.png";